import { message } from "antd";
import { useState } from "react";
import { SelectOption } from "../../../../../types/select";
import { OptionKeys } from "./searchByOptions";

export const useServiceRequestsSearch = () => {
  const [selectedSearchBy, setSelectedSearchBy] = useState<OptionKeys>("srNumber");
  const [searchValue, setSearchValue] = useState<string>();

  function handleSearch(value: string) {
    const length = value?.length ?? 0;

    if (length === 0) {
      setSearchValue(null);
      return;
    }

    if (length < 2) {
      message.error("Please enter at least two characters");
      return;
    }

    setSearchValue(value);
  }

  function handleChangeSearchBy(option: SelectOption<OptionKeys>) {
    setSelectedSearchBy(option?.value);
    setSearchValue(null);
  }

  return { selectedSearchBy, searchValue, handleSearch, handleChangeSearchBy };
};
